const SET_A = 0;
const SET_B = 1;
const SET_C = 2;
const SHIFT = 98;
const START_A = 103;
const START_B = 104;
const START_C = 105;
const MODULO = 103;
const STOP = 106;
const FNC1 = 207;
const SET_BY_CODE = {
  [START_A]: SET_A,
  [START_B]: SET_B,
  [START_C]: SET_C
};
const SWAP = {
  101: SET_A,
  100: SET_B,
  99: SET_C
};
const A_START_CHAR = String.fromCharCode(208);
const B_START_CHAR = String.fromCharCode(209);
const C_START_CHAR = String.fromCharCode(210);
const A_CHARS = "[\0-_\xC8-\xCF]";
const B_CHARS = "[ -\x7F\xC8-\xCF]";
const C_CHARS = "(\xCF*[0-9]{2}\xCF*)";
const BARS = [
  11011001100,
  11001101100,
  11001100110,
  10010011e3,
  10010001100,
  10001001100,
  10011001e3,
  10011000100,
  10001100100,
  11001001e3,
  11001000100,
  11000100100,
  10110011100,
  10011011100,
  10011001110,
  10111001100,
  10011101100,
  10011100110,
  11001110010,
  11001011100,
  11001001110,
  11011100100,
  11001110100,
  11101101110,
  11101001100,
  11100101100,
  11100100110,
  11101100100,
  11100110100,
  11100110010,
  11011011e3,
  11011000110,
  11000110110,
  10100011e3,
  10001011e3,
  10001000110,
  10110001e3,
  10001101e3,
  10001100010,
  11010001e3,
  11000101e3,
  11000100010,
  10110111e3,
  10110001110,
  10001101110,
  10111011e3,
  10111000110,
  10001110110,
  11101110110,
  11010001110,
  11000101110,
  11011101e3,
  11011100010,
  11011101110,
  11101011e3,
  11101000110,
  11100010110,
  11101101e3,
  11101100010,
  11100011010,
  11101111010,
  11001000010,
  11110001010,
  1010011e4,
  10100001100,
  1001011e4,
  10010000110,
  10000101100,
  10000100110,
  1011001e4,
  10110000100,
  1001101e4,
  10011000010,
  10000110100,
  10000110010,
  11000010010,
  1100101e4,
  11110111010,
  11000010100,
  10001111010,
  10100111100,
  10010111100,
  10010011110,
  10111100100,
  10011110100,
  10011110010,
  11110100100,
  11110010100,
  11110010010,
  11011011110,
  11011110110,
  11110110110,
  10101111e3,
  10100011110,
  10001011110,
  10111101e3,
  10111100010,
  11110101e3,
  11110100010,
  10111011110,
  10111101110,
  11101011110,
  11110101110,
  11010000100,
  1101001e4,
  11010011100,
  1100011101011
];
export {
  A_CHARS,
  A_START_CHAR,
  BARS,
  B_CHARS,
  B_START_CHAR,
  C_CHARS,
  C_START_CHAR,
  FNC1,
  MODULO,
  SET_A,
  SET_B,
  SET_BY_CODE,
  SET_C,
  SHIFT,
  START_A,
  START_B,
  START_C,
  STOP,
  SWAP
};
